'use strict';
(function () {
  angular.module('pentaApp').factory('professional.resource', service);

  service.$inject = ['$resource'];
  function service($resource) {
    return $resource('/progressiveApp/api/professional');
  }
})();
